import script from "./btsmsConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./btsmsConfig.vue?vue&type=script&lang=ts&setup=true"

import "./btsmsConfig.vue?vue&type=style&index=0&id=8e590c82&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e590c82"]])

export default __exports__